import React, { useEffect, useState } from "react";

import { Toast } from "react-bootstrap";
import { getAudienceTypeColor, BREAKPOINT } from "utils/styles";
import styled from "styled-components";

const Wrapper = styled.div`
  position: fixed;
  top: 5rem;
  right: 1rem;
  z-index: 100;

  & .toast {
    background: ${({ backgroundColor }) => backgroundColor};

    & .toast-header {
      align-items: end;
      font-size: 1.5rem;
      line-height: 1.3;

      & .close {
        font-size: 2.25rem;
        line-height: 0.7;
        opacity: 1;
      }
    }

    & .toast-body {
      font-size: 1rem;
      line-height: 1.3;
    }

    @media ${BREAKPOINT.M} {
      width: 300px;
      height: 400px;
      position: fixed;
      top: 50%;
      left: 50%;
      margin-top: -200px;
      margin-left: -150px;
      display: flex;
      flex-flow: column;

      justify-content: space-between;
    }
  }
`;

const Content = styled.div``;
const P = styled.p`
  margin: 0;
  padding: 0;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
const BodyFooterContent = styled.div`
  padding-top: 1rem;
  display: flex;

  ${({ hideOnTouch }) =>
    hideOnTouch
      ? `
    @media (hover: none) {
      display: none;
    }
  `
      : ""}
`;

const Keyboard = styled.svg`
  margin-right: 1rem;
  align-self: center;
`;

export const WELCOME_MESSAGE_PROFILE = "profile";
export const WELCOME_MESSAGE_FEED = "feed";

export default function WelcomeMessage({ activeAudience, type }) {
  const getLocalStoragifeKey = () => {
    if (type === WELCOME_MESSAGE_PROFILE) return "hideProfileWelcomeMessage";
    if (type === WELCOME_MESSAGE_FEED) return "hideFeedWelcomeMessage";
  };
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      try {
        if (!localStorage.getItem(getLocalStoragifeKey())) {
          setIsVisible(true);
        }
      } catch (error) {}
    }, 2000);
  }, []);

  const handleClose = () => {
    localStorage.setItem(getLocalStoragifeKey(), true);
    setIsVisible(false);
  };

  const renderHeader = () => {
    if (type === WELCOME_MESSAGE_PROFILE) {
      return (
        <strong className="mr-auto mabry-regular">
          Welcome to the <br></br>Profile Page
        </strong>
      );
    }

    if (type === WELCOME_MESSAGE_FEED) {
      return (
        <strong className="mr-auto mabry-regular">
          Welcome to the <br></br>Media Feed
        </strong>
      );
    }

    return "Unknown Welcome Message";
  };

  const renderBody = () => {
    if (type === WELCOME_MESSAGE_PROFILE) {
      return (
        <div>
          <P>
            Welcome to the audience profile of {activeAudience}. The profile
            includes values, narratives, and key demographic information along
            with the most popular media artifacts collected from 50,000+
            Americans between January and October 2020.{" "}
            <a href="/about/#method">Learn more about how we did this.</a>
          </P>
          <BodyFooterContent hideOnTouch>
            <Keyboard
              width="37"
              height="24"
              viewBox="0 0 37 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7188 9.42857C12.7188 10.5331 13.6142 11.4286 14.7188 11.4286H22.2812C23.3858 11.4286 24.2812 10.5331 24.2812 9.42857V2C24.2812 0.895433 23.3858 0 22.2812 0H14.7188C13.6142 0 12.7188 0.89543 12.7188 2V9.42857ZM18.0855 4.04316C18.2837 3.74927 18.7163 3.74927 18.9145 4.04316L20.2867 6.07756C20.5107 6.40965 20.2727 6.85714 19.8722 6.85714H17.1278C16.7273 6.85714 16.4893 6.40965 16.7133 6.07756L18.0855 4.04316ZM0 22C0 23.1046 0.895431 24 2 24H9.5625C10.6671 24 11.5625 23.1046 11.5625 22V14.5714C11.5625 13.4669 10.6671 12.5714 9.5625 12.5714H2C0.895431 12.5714 0 13.4669 0 14.5714V22ZM6.16239 16.5108C6.49483 16.2917 6.9375 16.5301 6.9375 16.9283V19.6432C6.9375 20.0413 6.49483 20.2797 6.16239 20.0607L4.10235 18.7032C3.8025 18.5056 3.8025 18.0658 4.10235 17.8682L6.16239 16.5108ZM12.7188 22C12.7188 23.1046 13.6142 24 14.7188 24H22.2812C23.3858 24 24.2812 23.1046 24.2812 22V14.5714C24.2812 13.4669 23.3858 12.5714 22.2812 12.5714H14.7188C13.6142 12.5714 12.7188 13.4669 12.7188 14.5714V22ZM19.8722 17.1429C20.2727 17.1429 20.5107 17.5904 20.2867 17.9224L18.9145 19.9568C18.7163 20.2507 18.2837 20.2507 18.0855 19.9568L16.7133 17.9224C16.4893 17.5904 16.7273 17.1429 17.1278 17.1429H19.8722ZM27.4375 12.5714C26.3329 12.5714 25.4375 13.4669 25.4375 14.5714V22C25.4375 23.1046 26.3329 24 27.4375 24H35C36.1046 24 37 23.1046 37 22V14.5714C37 13.4669 36.1046 12.5714 35 12.5714H27.4375ZM30.8376 20.0607C30.5052 20.2797 30.0625 20.0413 30.0625 19.6432V16.9283C30.0625 16.5301 30.5052 16.2917 30.8376 16.5108L32.8977 17.8682C33.1975 18.0658 33.1975 18.5056 32.8977 18.7032L30.8376 20.0607Z"
                fill="black"
              />
            </Keyboard>
            <P className="mabry-regular">
              You can use the arrow keys to instantly switch audience.
            </P>
          </BodyFooterContent>
        </div>
      );
    }

    if (type === WELCOME_MESSAGE_FEED) {
      return (
        <div>
          <P>
            Step inside a “day in the media life” of our 4 values-distinct
            audiences. These are real-life media artifacts collected from
            50,000+ Americans between January 2020 and May 2021.{" "}
            <a href="/about/#method">Learn more about how we did this.</a>.
          </P>
          <BodyFooterContent hideOnTouch>
            <Keyboard
              width="37"
              height="24"
              viewBox="0 0 37 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7188 9.42857C12.7188 10.5331 13.6142 11.4286 14.7188 11.4286H22.2812C23.3858 11.4286 24.2812 10.5331 24.2812 9.42857V2C24.2812 0.895433 23.3858 0 22.2812 0H14.7188C13.6142 0 12.7188 0.89543 12.7188 2V9.42857ZM18.0855 4.04316C18.2837 3.74927 18.7163 3.74927 18.9145 4.04316L20.2867 6.07756C20.5107 6.40965 20.2727 6.85714 19.8722 6.85714H17.1278C16.7273 6.85714 16.4893 6.40965 16.7133 6.07756L18.0855 4.04316ZM0 22C0 23.1046 0.895431 24 2 24H9.5625C10.6671 24 11.5625 23.1046 11.5625 22V14.5714C11.5625 13.4669 10.6671 12.5714 9.5625 12.5714H2C0.895431 12.5714 0 13.4669 0 14.5714V22ZM6.16239 16.5108C6.49483 16.2917 6.9375 16.5301 6.9375 16.9283V19.6432C6.9375 20.0413 6.49483 20.2797 6.16239 20.0607L4.10235 18.7032C3.8025 18.5056 3.8025 18.0658 4.10235 17.8682L6.16239 16.5108ZM12.7188 22C12.7188 23.1046 13.6142 24 14.7188 24H22.2812C23.3858 24 24.2812 23.1046 24.2812 22V14.5714C24.2812 13.4669 23.3858 12.5714 22.2812 12.5714H14.7188C13.6142 12.5714 12.7188 13.4669 12.7188 14.5714V22ZM19.8722 17.1429C20.2727 17.1429 20.5107 17.5904 20.2867 17.9224L18.9145 19.9568C18.7163 20.2507 18.2837 20.2507 18.0855 19.9568L16.7133 17.9224C16.4893 17.5904 16.7273 17.1429 17.1278 17.1429H19.8722ZM27.4375 12.5714C26.3329 12.5714 25.4375 13.4669 25.4375 14.5714V22C25.4375 23.1046 26.3329 24 27.4375 24H35C36.1046 24 37 23.1046 37 22V14.5714C37 13.4669 36.1046 12.5714 35 12.5714H27.4375ZM30.8376 20.0607C30.5052 20.2797 30.0625 20.0413 30.0625 19.6432V16.9283C30.0625 16.5301 30.5052 16.2917 30.8376 16.5108L32.8977 17.8682C33.1975 18.0658 33.1975 18.5056 32.8977 18.7032L30.8376 20.0607Z"
                fill="black"
              />
            </Keyboard>
            <P className="mabry-regular">
              You can use the arrow keys to instantly switch audience.
            </P>
          </BodyFooterContent>
        </div>
      );
    }

    return "This welcome message content hasn't been written";
  };

  return (
    <Wrapper backgroundColor={getAudienceTypeColor(activeAudience)}>
      <Toast show={isVisible} onClose={handleClose}>
        <Toast.Header>{renderHeader()}</Toast.Header>
        <Toast.Body>{renderBody()}</Toast.Body>
      </Toast>
    </Wrapper>
  );
}
